
export const setupHoverVideoHandlers = () => {
  setTimeout(() => {
    document.querySelectorAll('.content-item').forEach(item => {
      const video = item.querySelector('.hover-video') as HTMLElement | null;
      
      if (video) {
        // Show video container on hover
        item.addEventListener('mouseenter', () => {
          video.style.display = 'block';
          
          // If it's a video element, play it
          const videoEl = video.querySelector('video');
          if (videoEl) {
            videoEl.play().catch(e => console.log('Autoplay prevented:', e));
          }
          
          // If thumbnail image exists, hide it
          const img = item.querySelector('.content-image');
          if (img) {
            img.classList.add('opacity-0');
          }
        });
        
        // Hide video container on mouse leave
        item.addEventListener('mouseleave', () => {
          video.style.display = 'none';
          
          // If it's a video element, reset it
          const videoEl = video.querySelector('video');
          if (videoEl) {
            videoEl.pause();
            videoEl.currentTime = 0;
          }
          
          // Show thumbnail image again
          const img = item.querySelector('.content-image');
          if (img) {
            img.classList.remove('opacity-0');
          }
        });
      }
    });
  }, 1000); // Delay to ensure DOM elements are loaded
};

export const trocarParaIframe = () => {
  const heroBackground = document.getElementById('hero-background');
  const iframeContainer = document.getElementById('hero-iframe-container');
  
  if (heroBackground && iframeContainer) {
    heroBackground.style.display = 'none';
    iframeContainer.style.display = 'block';
    
    // Request fullscreen
    if (iframeContainer.requestFullscreen) {
      iframeContainer.requestFullscreen().catch(err => {
        console.error('Error attempting to enable fullscreen:', err);
      });
    } else if ((iframeContainer as any).webkitRequestFullscreen) {
      (iframeContainer as any).webkitRequestFullscreen();
    } else if ((iframeContainer as any).msRequestFullscreen) {
      (iframeContainer as any).msRequestFullscreen();
    }
  }
};
